import {type AppState} from '../../types/app-state'
import {UserAgentApplication} from 'msal'

export const authTokenSelector = (state: AppState): string | undefined => state.auth.authToken

export const hasAuthTokenSelector = (state: AppState): boolean =>
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    state.auth.authToken ? state.auth.authToken?.length > 0 : false

export const msalSelector = (state: AppState): UserAgentApplication | undefined => state.auth.msal
